module.exports = __webpack_public_path__ + "img/no-area.706961bf.png";